// Shared constants for the MCP OAuth consent flow. Lives here (and not on the page file)
// so the auth hook can import it without pulling the page bundle into its import graph.

// Namespaced to avoid collisions on the same eTLD+1 with unrelated apps.
export const CONNECT_AI_PENDING_REQUEST_KEY = 'aspe_connect_ai_pending_request';

export const CONNECT_AI_AUTHORIZE_PATH = '/connect-ai/authorize';
